import React from "react";
import axios from "axios";

import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { prefixer } from "stylis";

import banner2 from "./assets/bannernew.jpg";

import {
  Container,
  Box,
  Stack,
  Typography,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  CircularProgress,
  Snackbar,
  Alert,
  FormGroup,
  Checkbox,
} from "@mui/material";

interface IFormObj {
  interviewType: string;
  interviewerName: string;
  applicantName: string;
  applicantNumber: string;

  leadership: string;

  leadershipDetails: string;

  businessOrientaion: string;
  businessOrientaionDetails: string;
  skills: string;
  skillsDetails: string;
  globalOrientaion: string;
  globalOrientaionDetails: string;
  relationships: string;
  relationshipsDetails: string;
  recruiterRecommendation: any;
  customerExp: string; // New field
  customerExpDetails: string; // New field
  relevantImpressions: string;
  evaluation: string;

  evaluationPros: string;
  evaluationCons: string;
  recommendation: string;
  relevantKnowledge: string;
  relevantKnowledgeB: string;
  // isRelated: string;
  isExcel: string;
  isXFactorTitle: string;
  isXFactor: string;

  englishVocabulary: string;
  englishGrammar: string;

  englishQuestion: string;
  impressionOfInterview: string;

  impressionRank: string;

  specialRequests: string;

  advisoryMatchB: string;
  advisoryMatchDetailsB: string;
  businessOrientaionB: string;
  businessOrientaionDetailsB: string;
  skillsB: string;
  skillsDetailsB: string;
  leadershipB: string;
  leadershipDetailsB: string;
  relationshipsB: string;
  relationshipsDetailsB: string;
  globalOrientaionB: string;
  globalOrientaionDetailsB: string;

  relevantImpressionsB: string;
  profileMatch: string;
  profileMatchDetails: string;

  // New fields for "ראיון מקצועי - מתמחים"
  leadershipInterns: string;
  leadershipInternsDetails: string;
  businessOrientaionInterns: string;
  businessOrientaionInternsDetails: string;
  skillsInterns: string;
  skillsInternsDetails: string;
  globalOrientaionInterns: string;
  globalOrientaionInternsDetails: string;
  relationshipsInterns: string;
  relationshipsInternsDetails: string;
  customerExpInterns: string;
  customerExpInternsDetails: string;
  personalResilience: string;
  personalResilienceDetails: string;
  exceptionalSkills: string;
  exceptionalSkillsHasSkills: string;
  exceptionalSkillsDetails: string;
  technologyAdoption: string;
  technologyAdoptionDetails: string;
}

interface FieldProps {
  formObj: IFormObj;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  fieldKey: keyof IFormObj;
  fieldKeyTwo?: keyof IFormObj;
  fieldKeyThree?: keyof IFormObj;
  allTitles: IFormObj;
  errorsObj: Partial<IFormObj>;
  detailsFieldKey?: keyof IFormObj;
  fieldType?: "text" | "rank" | "multiline" | "multiSelect" | "yesNoRadio";
  options?: Option[];
  handleCheckboxChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  maxRank?: number;
}

interface snackbarDataProps {
  open: boolean;
  severity: "error" | "success";
  msg?: string;
}

const cacheLtr = createCache({
  key: "muiltr",
});

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const themeComponents = {
  MuiFormLabel: {
    styleOverrides: {
      root: {
        "&.Mui-error": {
          fontWeight: "bold",
        },
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        "& .MuiOutlinedInput-root.Mui-error": {
          "& fieldset": {
            borderWidth: "2px",
          },
        },
      },
    },
  },
};

const ltrTheme = createTheme({ direction: "ltr", components: themeComponents });
const rtlTheme = createTheme({ direction: "rtl", components: themeComponents });

const allTitles: IFormObj = {
  interviewType: "סמן",
  interviewerName: "שם המראיין/ת",
  applicantName: "שם המועמד/ת",
  applicantNumber: "טלפון נייד של המועמד/ת",
  recruiterRecommendation: "המלצת המגייסת לשיבוץ באשכול",
  // leadership: 'כושר מנהיגות - אסרטיביות, יכולת הובלה, יכולת עבודה עצמאית, ערכיות, קבלת ביקורת וסמכות, קבלת מרות, גמישות בינאישית, חוסן פנימי, זיהוי פוטנציאל ניהולי',
  leadership: `<u>מימד 1 - מנהיגות</u><br>
<u>השפעה</u> - היכולת להשפיע, לשמש דוגמה ולסייע לאנשים אחרים לייצר ערך<br>
ליצור אווירה חיובית, לדעת שאין לי את כל התשובות ולעודד גם אחרים לשאול שאלות, לתרגל הקשבה אמפתיה וקידום רווחתם של אחרים, לעשות את מה שאמרתי ולהגיד את מה שאני עושה, ליצור סביבה מכבדת המאפשרת לכולם להשמיע את כולם ולהרגיש שייכים.
`,
  leadershipDetails: "פירוט",
  // businessOrientaion: 'אוריינטציה עסקית  - הבנת העולם העיסקי, חשיבה אנליטית, יכולות ניתוח, יכולת יצירת קשרים, יוזמה, יכולת קבלת החלטות',
  businessOrientaion: `<u>העצמה</u> - היכולת לחזק את האחר ולעבוד בשיתוף פעולה אמיתי ומלא\n
להקפיד על תקשורת רציפה, להציג את הרציונל והמטרה של כל פעולה שאני עושה ולהראות איך העשייה של כולם משתלבת בזה,
לגלות גמישות לשינויים, לסייע לאחרים לצלוח משברים ולחזק את הביטחון שלהם,
לסמוך על אחרים ועל ההחלטות שלהם, להגיד את האמת, גם כשהיא לא נעימה`,

  businessOrientaionDetails: "פירוט",
  // skills: 'יכולות מקצועיות - יכולות למידה, יסודיות, שיטתיות, אחריות, עמידה בלחצים, הבחנה בין עיקר לתפל , שימוש בידע באופן רוחבי, יצירת ידע ושיתופו',
  skills: `<u>התפתחות</u> - השאיפה שלי היא לצמוח ולהתפתח, אישית ומקצועית\n
להציג דעות והשקפות ייחודיות במטרה לפתח את המחשבה, לבנות קהילות וצוותים מכילים שבהם יש מקום לאנשים, כישורים ורעיונות מגוונים,
להיות בלמידה מתמדת, לשקף ולשתף אחרים במה שלמדתי, להתנסות ולחפש פתרונות יוצאי דופן,
לפעול מתוך סקרנות ולעודד סקרנות אצל אחרים`,

  skillsDetails: "פירוט",
  // globalOrientaion: 'אוריינטציה גלובלית - יצירת קשרים גלובליים, שפות, פרספקטיבה גלובלית, עבודה בסביבות מגוונות ו/או משתנות',
  globalOrientaion: `<u>מימד 2 - יצירת ערך</u>\n\n
<u>מצוינות </u> - המחויבות לאיכות, יושרה וסובלנות\n
לתרום לתהליכי עבודה יעילים שיאפשרו תוצאות מיטביות, לנהל סיכונים על ידי עבודה לפי מדיניות/נהלים וייעוץ הפירמה,
לסייע ולתמוך באחרים, לנהוג בצורה אתית ולהשמיע את קולי כנגד התנהגות לא נאותה,
לבצע עבודה איכותית באובייקטיביות מקצועית, מיומנות ואכפתיות`,
  globalOrientaionDetails: "פירוט",
  // relationships: 'מערכות יחסים - יכולת השפעה ושכנוע, יכולת יצירת קשרים בלתי פורמליים, שירותיות, יחסי אנוש, יכולת עבודה בצוות, פתיחות וקבלת האחר, לויאליות',
  relationships: `<u>תרומה להצלחה</u> - בעבודה שלי משולבות פעולות ויוזמות המיועדות להביא ערך ולתרום להצלחתה העסקית של הפירמה\n
ליצור קשרים משמעותיים על ידי התחשבות בצורך של האחר, ליצור ערך על ידי חיבור בין לקוחות ולקוחות עתידיים ליכולות ופתרונות של הפירמה,
לתכלל אירועים גלובליים, מקומיים וטרנדים מהותיים, לפתח כלים ומומחיות כדי להצטיין במה שאני עושה,
ליצור ערך משמעותי אשר יאפשר התמודדות עם אתגרים`,

  relationshipsDetails: "פירוט",
  customerExp: `<u>חווית לקוח</u> - כל אחד ואחת מאיתנו בפירמה וברשת PwC עובדים יחד, בשיתוף פעולה מלא, כדי לספק ללקוחות שלנו ערך עסקי, פתרונות איכותיים וחווית לקוח יוצאת דופן\n
לעבוד יחד כדי לפתור אתגרים עכשווים תוך התחשבות באתגרי העתיד,
לשפר את ההשפעה שלי על ידי קבלת ומתן משוב, לגלות אחריות, יחד עם עמיתיי, לספק ללקוח חווית שירות יוצאת דופן,
להשתמש בטכנולוגיות חדשניות ומתקדמות כדי לחדש ולספק ערך, לנהוג בפתיחות לדעות מגוונות כדי לספק את התוצאה הטובה ביותר`,
  customerExpDetails: "פירוט",
  relevantImpressions: "סיכום ראיון התרשמות לגבי מועמד",
  evaluation: "הערכה מסכמת",
  evaluationPros: "התרשמות חיובית",
  evaluationCons: "נושאים לשיפור",
  recommendation: "המלצה",
  relevantKnowledge:
    "דגשים וידע רלוונטי לתפקיד (זמינות, ציפיות שכר, תעודות וכדומה)",

  relevantKnowledgeB: "דגשים וידע רלוונטי לתפקיד",

  // isRelated: 'האם המועמד קשור ללקוח / חברה / קרוב משפחה של עובד?',
  isExcel: "האם המועמד/ת מומלצ/ת להשתתפות בתוכנית מצטיינים?",
  isXFactorTitle: "שאלת ה-X-Factor",
  isXFactor: `מעבר לניסיון מקצועי, ציונים או כישורים - האם במהלך הראיון זיהית באופן חד משמעי איכות או יכולת ייחודית המבדלת את המועמד ועשויה לרמז על פוטנציאל גבוה, הצלחה בתפקיד והתאמה לתרבות הארגונית
לדוגמה - תחביב יוצא דופן או עיסוק ספורטיבי, עולם תוכן עשיר, מאפיין אישיותי משמעותי (כריזמה/חדות מחשבה/ אוריינטציה עסקית גבוהה מאוד) - הדוגמאות הנ"ל עשויות להעיד על התמדה, העמקה, מצויינות, סקרנות, שאפתנות ומסוגלות גבוהה`,
  englishVocabulary: "אנגלית - אוצר מילים",
  englishGrammar: "אנגלית - יכולת דקדוק",

  englishQuestion:
    "מענה על שאלה באנגלית בכתב במהלך הראיון (עבור ראיון וירטואלי)",
  impressionOfInterview: "סיכום ראיון - התרשמות לגבי המועמד",

  impressionRank: "סיכום כללי - התרשמות לגבי המועמד",

  specialRequests: "בקשות מועמד לגבי שיבוץ לאשכול/מחלקה",

  advisoryMatchB:
    "מימד 1 - מנהיגות\n\nהשפעה - היכולת להשפיע, לשמש דוגמה ולסייע לאנשים אחרים לייצר ערך\n\nליצור אווירה חיובית, לדעת שאין לי את כל התשובות ולעודד גם אחרים לשאול שאלות, לתרגל הקשבה אמפתיה וקידום רווחתם של אחרים, לעשות את מה שאמרתי ולהגיד את מה שאני עושה, ליצור סביבה מכבדת המאפשרת לכולם להשמיע את כולם ולהרגיש שייכים",
  advisoryMatchDetailsB: "פירוט",
  // businessOrientaionB: 'אוריינטציה עסקית - זיקה לעולם העסקי, התעניינות בעולמות התוכן העסקיים והפיננסיים, סקרנות ומוטיבציה',
  businessOrientaionB: `<u>העצמה</u> - היכולת לחזק את האחר ולעבוד בשיתוף פעולה אמיתי ומלא\n
להקפיד על תקשורת רציפה, להציג את הרציונל והמטרה של כל פעולה שאני עושה ולהראות איך העשייה של כולם משתלבת בזה,
לגלות גמישות לשינויים, לסייע לאחרים לצלוח משברים ולחזק את הביטחון שלהם,
לסמוך על אחרים ועל ההחלטות שלהם, להגיד את האמת, גם כשהיא לא נעימה`,
  businessOrientaionDetailsB: "פירוט",
  // skillsB: 'התרשמות מקצועית - יכולות אנליטיות, נתונים לימודיים, יכולות לימוד, תפיסה מהירה, התמודדות עם מצבי לחץ, אבחנה בין עיקר לטפל, יסודיות, אחריות, התמדה/דבקות במשימה',
  skillsB: `<u>התפתחות</u> - השאיפה שלי היא לצמוח ולהתפתח, אישית ומקצועית\n
להציג דעות והשקפות ייחודיות במטרה לפתח את המחשבה, לבנות קהילות וצוותים מכילים שבהם יש מקום לאנשים, כישורים ורעיונות מגוונים,
להיות בלמידה מתמדת, לשקף ולשתף אחרים במה שלמדתי, להתנסות ולחפש פתרונות יוצאי דופן,
לפעול מתוך סקרנות ולעודד סקרנות אצל אחרים`,
  skillsDetailsB: "פירוט",
  // leadershipB: 'כושר מנהיגות - ייצוגיות, זיהוי פוטנציאל ניהולי, כושר שכנוע, ביטחון עצמי, וורבליות, יכולות אסרטיביות',
  leadershipB: `<u>מימד 2 - יצירת ערך</u>\n\n
<u>מצוינות </u> - המחויבות לאיכות, יושרה וסובלנות\n
לתרום לתהליכי עבודה יעילים שיאפשרו תוצאות מיטביות, לנהל סיכונים על ידי עבודה לפי מדיניות/נהלים וייעוץ הפירמה,
לסייע ולתמוך באחרים, לנהוג בצורה אתית ולהשמיע את קולי כנגד התנהגות לא נאותה,
לבצע עבודה איכותית באובייקטיביות מקצועית, מיומנות ואכפתיות`,
  leadershipDetailsB: "פירוט",
  // relationshipsB: 'יחסים בינאישיים ועבודה בצוות - יכולת עבודה בצוות, פתיחות וקבלת האחר, יכולת יצירת קשרים בלתי פורמליים, שירותיות, יחסי אנוש, לויאליות יכולת השפעה',
  relationshipsB: `<u>תרומה להצלחה</u> - בעבודה שלי משולבות פעולות ויוזמות המיועדות להביא ערך ולתרום להצלחתה העסקית של הפירמה\n
ליצור קשרים משמעותיים על ידי התחשבות בצורך של האחר, ליצור ערך על ידי חיבור בין לקוחות ולקוחות עתידיים ליכולות ופתרונות של הפירמה,
לתכלל אירועים גלובליים, מקומיים וטרנדים מהותיים, לפתח כלים ומומחיות כדי להצטיין במה שאני עושה,
ליצור ערך משמעותי אשר יאפשר התמודדות עם אתגרים`,
  relationshipsDetailsB: "פירוט",
  // globalOrientaionB: 'אוריינטציה גלובלית - יצירת קשרים גלובליים, שפות, פרספקטיבה גלובלית, עבודה בסביבות מגוונות ו/או משתנות',
  globalOrientaionB: `<u>מימד 2 - יצירת ערך</u>\n\n
<u>מצוינות </u> - המחויבות לאיכות, יושרה וסובלנות\n
לתרום לתהליכי עבודה יעילים שיאפשרו תוצאות מיטביות, לנהל סיכונים על ידי עבודה לפי מדיניות/נהלים וייעוץ הפירמה,
לסייע ולתמוך באחרים, לנהוג בצורה אתית ולהשמיע את קולי כנגד התנהגות לא נאותה,
לבצע עבודה איכותית באובייקטיביות מקצועית, מיומנות ואכפתיות`,
  globalOrientaionDetailsB: "פירוט",

  relevantImpressionsB: "סיכום ראיון - התרשמות לגבי מועמד",
  profileMatch:
    "התאמה לפרופיל יועץ - יכולת פרזנטטיביות, חדשנות, יכולת עבודה עצמית, אוטודידקטיות, סדר וארגון, חשיבה מחוץ לקופסא, יוזמה, יצירתיות",
  profileMatchDetails: "פירוט",

  // New titles specifically for "ראיון מקצועי - מתמחים"
  leadershipInterns: `<div style="line-height:1.1"><u>מיומנויות עיקריות</u><br style="margin:0">
	<b>גישה חיובית ונעימה (מנהיגות - השפעה)</b><br style="margin:0">
שמירה על גישה נעימה ומכבדת שתורמת ליצירת סביבת עבודה תומכת, פתוחה ומקצועית. גישה שמקדמת שיתוף פעולה, תקשורת אפקטיבית ותחושת ביטחון בקרב חברי הצוות<br style="margin:0">
</div>
דוגמאות להתנהגויות:
<ul style="margin:0;line-height:0.9"> 
<li style="margin:0;padding:2px 0">מפגין אדיבות וסבלנות גם במצבים מאתגרים או לחוצים</li>
<li style="margin:0;padding:2px 0">מגיב באופן ענייני ובונה לביקורת או לקונפליקטים</li>
<li style="margin:0;padding:2px 0">תורם לתחושת שייכות ונוחות שמקדמת מוטיבציה ושיתוף פעולה בקרב חברי הצוות </li>
</ul>
`,
  leadershipInternsDetails: "פירוט",

  businessOrientaionInterns: `<div style="line-height:1.1"><b>יכולות בינאישיות מצוינות (מנהיגות - העצמה)</b><br style="margin:0">
	היכולת לעבוד בצוות, ליצור תקשורת חיובית, לשתף פעולה עם מגוון גורמים, לרתום שותפים למשימות משותפות, ולבנות מערכות יחסים מקצועיות שמקדמות הצלחה<br style="margin:0">
</div>
דוגמאות להתנהגויות:
<ul style="margin:0;line-height:0.9"> 
<li style="margin:0;padding:2px 0">יוזם תקשורת ברורה ומקדמת עם עמיתים, מנהלים ולקוחות</li>
<li style="margin:0;padding:2px 0">שומר על אווירה חיובית גם במצבים של חוסר הסכמה</li>
<li style="margin:0;padding:2px 0">תורם לגיבוש הצוות ולשיתוף ידע</li>
</ul>`,
  businessOrientaionInternsDetails: "פירוט",

  skillsInterns: `<div style="line-height:1.1"><b>יכולת הסתגלות מהירה לסביבה משתנה (מנהיגות - העצמה)</b><br style="margin:0">
היכולת להתמודד עם שינויים תכופים, חוסר ודאות, הסתגלות מהירה לדרישות משתנות, לקוחות שונים וסביבות עבודה מגוונות<br style="margin:0">
</div>
דוגמאות להתנהגויות:
<ul style="margin:0;line-height:0.9"> 
<li style="margin:0;padding:2px 0">מגלה גמישות מחשבתית כאשר מתבקשים שינויים פתאומיים במשימות או בלוחות זמנים</li>
<li style="margin:0;padding:2px 0">שומר על רמת ביצוע גבוהה גם כאשר התנאים אינם אידיאליים או ברורים</li>
<li style="margin:0;padding:2px 0">מפגין חוסן ויכולת פתרון בעיות כאשר נדרש להתמודד עם חוסר ודאות</li>
</ul>`,
  skillsInternsDetails: "פירוט",

  globalOrientaionInterns: `<div style="line-height:1.1"><b>מוטיבציה פנימית להתפתחות מקצועית (מנהיגות - התפתחות)</b><br style="margin:0">
	דחף אישי ללמוד, להתפתח ולהשתפר באופן מתמיד תוך הפגנת סקרנות, יוזמה ורצון להעמיק ידע. רצון להרחבת מיומנויות מקצועיות גם מעבר לדרישות המיידיות<br style="margin:0">
</div>
	דוגמאות להתנהגויות:
<ul style="margin:0;line-height:0.9"> 
	<li style="margin:0;padding:2px 0">מחפש הזדמנויות להתנסות, להתקדם ולהרחיב את תחומי האחריות או הידע מעבר למצופה ממנו</li>
		<li style="margin:0;padding:2px 0">מציע רעיונות לשיפור תהליכים או דרכי עבודה</li>
			<li style="margin:0;padding:2px 0">שואף לקבל משוב וליישם אותו כדי להשתפר</li>
	</ul>`,
  globalOrientaionInternsDetails: "פירוט",

  relationshipsInterns: `<div style="line-height:1.1"><b>חשיבה ביקורתית ויכולת ניתוח גבוהה (יצירת ערך - מצוינות)</b><br style="margin:0">
היכולת להבין תהליכים מורכבים, לנתח מידע, לזהות דפוסים ולהפיק תובנות משמעותיות המסייעות בקבלת החלטות ובזיהוי סיכונים<br style="margin:0"/>
</div>
דוגמאות להתנהגויות:
<ul style="margin:0;line-height:0.9">
  <li style="margin:0;padding:2px 0">שואל שאלות המעמיקות את ההבנה של תהליכים</li>
  <li style="margin:0;padding:2px 0">מציע הסברים אפשריים תוך שימוש בהיגיון ובידע מקצועי</li>
  <li style="margin:0;padding:2px 0">שומר על גישה ביקורתית גם מול מידע שנראה תקין לכאורה</li>
</ul>`,
  relationshipsInternsDetails: "פירוט",

  customerExpInterns: `<div style="line-height:1.1"><b>ניהול זמן ועמידה בלוחות זמנים (יצירת ערך - מצוינות)</b><br style="margin:0">
היכולת לתכנן, לתעדף ולבצע משימות באופן אפקטיבי גם תחת עומס ולוחות זמנים צפופים, תוך שמירה על איכות ביצוע גבוהה ועמידה ביעדים שנקבעו<br style="margin:0"/>
</div>
דוגמאות להתנהגויות:
<ul style="margin:0;line-height:0.9">
  <li style="margin:0;padding:2px 0">מתכנן את סדר היום והמשימות לפי דחיפות וחשיבות</li>
  <li style="margin:0;padding:2px 0">מזהה עומסים מראש ומבצע התאמות נדרשות</li>
  <li style="margin:0;padding:2px 0">שומר על איכות עבודה גבוהה גם כשנדרש לעבוד במהירות</li>
</ul>`,
  customerExpInternsDetails: "פירוט",

  personalResilience: `<div style="line-height:1.1"><b>חוסן אישי (יצירת ערך - חווית לקוח)</b><br style="margin:0">
היכולת לשמור על תפקוד מיטבי, יציבות רגשית ותגובה מקצועית עניינית גם בסביבה דינמית, משתנה ומאתגרת. החוסן מתבטא בהתמודדות אפקטיבית עם מצבים מורכבים תוך שמירה על איכות ביצוע גבוהה<br style="margin:0"/>
</div>
דוגמאות להתנהגויות:
<ul style="margin:0;line-height:0.9">
  <li style="margin:0;padding:2px 0">מגיב באחריות ובשיקול דעת למצבים של תסכול, חוסר הצלחה או ביקורת</li>
  <li style="margin:0;padding:2px 0">מתמודד עם אתגרים בגישה חיובית וממוקדת פתרון</li>
  <li style="margin:0;padding:2px 0">מבקש עזרה או תעדוף כשנדרש, מבלי לאבד שליטה או מוטיבציה</li>
</ul>`,
  personalResilienceDetails: "פירוט",
  
  exceptionalSkills: `<div style="line-height:1.1"><b>זיהוי מיומנות יוצאת דופן</b><br style="margin:0">
במהלך הראיון, האם אחת או יותר מהמיומנויות באה לידי ביטוי באופן מרשים במיוחד?<br style="margin:0"/>
(יכולת הסתגלות לסביבה משתנה, אימוץ טכנולוגיות חדשות, חשיבה ביקורתית וניתוח, חוסן אישי ועמידות בלחץ, מוטיבציה להתפתחות מקצועית, יכולות בינאישיות, גישה חיובית ונעימה, ניהול זמן ועמידה בזמנים)</div>`,
  exceptionalSkillsHasSkills: "האם יש מיומנויות יוצאות דופן?",
  exceptionalSkillsDetails: "פירוט",
    
  technologyAdoption: `<div style="line-height:1.1"><b>אימוץ מהיר של טכנולוגיות חדשות (יצירת ערך - תרומה להצלחה/חווית לקוח)</b><br style="margin:0">
היכולת להסתגל במהירות לסביבות עבודה דיגיטליות חדשות תוך למידה עצמאית של מערכות ושילובן באופן אפקטיבי בתהליכי עבודה<br style="margin:0"/>
</div>
דוגמאות להתנהגויות:
<ul style="margin:0;line-height:0.9">
  <li style="margin:0;padding:2px 0">מגלה סקרנות טכנולוגית ונכונות להתנסות בפלטפורמות חדשות</li>
  <li style="margin:0;padding:2px 0">משלב כלים חדשים באופן שמייעל תהליכים או משפר תוצרים</li>
  <li style="margin:0;padding:2px 0">מבצע חקר עצמי או פונה לעמיתים כדי להבין כיצד להשתמש בטכנולוגיה בצורה מיטבית</li>
</ul>`,
  technologyAdoptionDetails: "פירוט",
};

// Titles that override allTitles for the two Advisory interview types only
// (keys are shared with other interview types, so the override is applied per type in App).
const advisoryTitles: Partial<IFormObj> = {
  profileMatch: `<div style="line-height:1.1"><b>אוטודידקטיות ולמידה עצמאית</b><br style="margin:0">היכולת ללמוד באופן עצמאי, לקלוט מידע חדש במהירות, לנתח ולהבין תהליכים מורכבים תוך הפגנת יוזמה אישית, למידה מטעויות ושימוש במשוב לשיפור מתמיד.<br style="margin:0"></div><u>התנהגויות תומכות:</u><ul style="margin:0;line-height:0.9"><li style="margin:0;padding:2px 0">יודע לחקור וללמוד נושאים באופן עצמאי באמצעות מקורות מידע מגוונים</li><li style="margin:0;padding:2px 0">מפגין יכולת קליטה מהירה של מידע חדש - תהליכים, מערכות או דרישות מקצועיות.</li><li style="margin:0;padding:2px 0">שואל שאלות ענייניות כדי להעמיק הבנה כאשר נתקל בחוסר ידע או במידע שאינו ברור.</li></ul>`,
  leadership: `<div style="line-height:1.1"><b>מולטיטסקינג, עבודה בזמנים, וסדר וארגון</b><br style="margin:0">היכולת לתכנן, לתעדף ולבצע משימות באופן אפקטיבי, גם תחת עומס ולוחות זמנים צפופים, תוך שמירה על איכות ביצוע גבוהה ועמידה ביעדים שנקבעו.<br style="margin:0"></div><u>התנהגויות תומכות:</u><ul style="margin:0;line-height:0.9"><li style="margin:0;padding:2px 0">מתכנן את המשימות המרובות לפי דחיפות וחשיבות ומזהה עומסים מראש ומבצע התאמות נדרשות</li><li style="margin:0;padding:2px 0">עומד בלוחות זמנים שנקבעו, גם כשיש משימות מרובות</li><li style="margin:0;padding:2px 0">שומר על איכות עבודה גבוהה גם כשנדרש לעבוד במהירות</li></ul>`,
  businessOrientaionB: `<div style="line-height:1.1"><b>אוריינטציה עסקית</b><br style="margin:0">היכולת להבין את ההקשר העסקי הרחב של הפעילות, לזהות הזדמנויות לשיפור ביצועים, לחשוב מתוך ראייה מערכתית ולפעול באופן שמקדם את מטרות הארגון, הלקוח והצוות.<br style="margin:0"></div><u>התנהגויות תומכות:</u><ul style="margin:0;line-height:0.9"><li style="margin:0;padding:2px 0">מתעניין במתרחש בשוק ובמגמות כלכליות דרך קריאת עיתונות כלכלית, האזנה לפודקאסטים מקצועיים או מעקב אחר מקורות מידע רלוונטיים</li><li style="margin:0;padding:2px 0">מגלה זיקה יזמית - משתתף במועדונים אקדמיים, פרויקטים יזמיים או בעל ניסיון אישי בניהול עסק</li><li style="margin:0;padding:2px 0">עוקב אחר המתרחש בשוק ההון, קורא דוחות כספיים</li></ul>`,
  skillsB: `<div style="line-height:1.1"><b>יכולת הסתגלות מהירה לסביבה משתנה</b><br style="margin:0">היכולת להתמודד עם שינויים תכופים, חוסר ודאות, הסתגלות מהירה לדרישות משתנות, לקוחות שונים וסביבות עבודה מגוונות.<br style="margin:0"></div><u>התנהגויות תומכות:</u><ul style="margin:0;line-height:0.9"><li style="margin:0;padding:2px 0">מגלה גמישות מחשבתית כאשר מתבקשים שינויים פתאומיים במשימות או בלוחות זמנים</li><li style="margin:0;padding:2px 0">לומד במהירות תהליכים חדשים, מערכות חדשות או דרישות לקוח משתנות</li><li style="margin:0;padding:2px 0">מפגין חוסן ויכולת פתרון בעיות כאשר נדרש להתמודד עם חוסר ודאות</li></ul>`,
  globalOrientaion: `<div style="line-height:1.1"><b>יצירתיות וחשיבה מחוץ לקופסא</b><br style="margin:0">היכולת לזהות הזדמנויות לשיפור, לחשוב מחוץ לקופסה, וליצור פתרונות חדשניים לאתגרים מקצועיים.<br style="margin:0"></div><u>התנהגויות תומכות:</u><ul style="margin:0;line-height:0.9"><li style="margin:0;padding:2px 0">מציע רעיונות לשיפור תהליכים או שירותים, בין אם ביוזמתו האישית או בעקבות זיהוי בעיה קיימת.</li><li style="margin:0;padding:2px 0">מתמודד עם אתגרים מקצועיים בגישה יצירתית, תוך שימוש בכלים או גישות שאינן שגרתיות.</li><li style="margin:0;padding:2px 0">יוזם פעולות של פרויקטים או תהליכים חדשים, גם כאשר לא נדרש לכך באופן ישיר.</li></ul>`,
  relationshipsB: `<div style="line-height:1.1"><b>מוטיבציה, זיקה לתחום ושאיפות מקצועיות</b><br style="margin:0">דחף אישי ללמוד, להתפתח ולהשתפר באופן מתמיד תוך הפגנת סקרנות, יוזמה ורצון להעמיק ידע ולהרחיב מיומנויות מקצועיות גם מעבר לדרישות המיידיות.<br style="margin:0"></div><u>התנהגויות תומכות:</u><ul style="margin:0;line-height:0.9"><li style="margin:0;padding:2px 0">מציע רעיונות לשיפור תהליכים או דרכי עבודה</li><li style="margin:0;padding:2px 0">שואף לקבל משוב וליישם אותו כדי להשתפר</li><li style="margin:0;padding:2px 0">מחפש הזדמנויות להתנסות, להתקדם ולהרחיב את תחומי האחריות</li></ul>`,
  customerExp: `<div style="line-height:1.1"><b>הבנה מקצועית</b><br style="margin:0">היכולת להפגין ידע עדכני ורלוונטי בתחומי הכלכלה, שוק ההון, מימון והערכות שווי, לצד סקרנות מקצועית, מעורבות בעולם העסקי ויכולת ליישם מושגים תיאורטיים בהקשרים מעשיים.<br style="margin:0"></div><u>התנהגויות תומכות:</u><ul style="margin:0;line-height:0.9"><li style="margin:0;padding:2px 0">היכולת לנתח את זרמי ההכנסות וההוצאות העיקריות של עסק (מחוללי ערך עיקריים)</li><li style="margin:0;padding:2px 0">התמצאות בדוחות כספיים, הבנת מושגי יסוד של מימון כגון ריבית, אנונה, ויודע לקשר את ההשפעה על הפעילות העסקית.</li><li style="margin:0;padding:2px 0">מכיר שיטות להערכת שווי (מכפיל, היוון תזרימים) ויודע ליישם אותן על עסקים</li></ul>`,
  evaluationPros: "התרשמות לחיוב",
  evaluationCons: "התרשמות לשלילה",
  impressionRank: `<b>סיכום כללי - התרשמות לגבי המועמד / התאמה לפרופיל היועץ</b><br>1 - ממליץ/ה מאוד: התאמה גבוהה ביותר לדרישות<br>2 - ממליץ/ה: התרשמות טובה, מועמד/ת מתאים/ה<br>3 - לא זוהה התאמה למחלקה`,
};

interface Option {
  value: string;
  label: string;
}
const options: Option[] = [
  { value: "מארק", label: "מארק" },
  { value: "טל", label: "טל" },
  { value: "מיה", label: "מיה" },
  { value: "שחר", label: "שחר" },
  { value: "ברקו", label: "ברקו" },
  { value: "נגב", label: "נגב" },
  { value: "שחר ירושלים", label: "שחר ירושלים" },
  { value: "ברק חיפה", label: "ברק חיפה" },
  { value: "RAS", label: "RAS" },
  { value: "CMAAS", label: "CMAAS" },
  { value: "מקצועית", label: "מקצועית" },
];

const YesNoRadio = (props: FieldProps) => {
  const hasError = !!(props.errorsObj && props.errorsObj[props.fieldKey]);
  const hasError2 = !!(
    props.errorsObj &&
    props.detailsFieldKey &&
    props.errorsObj[props.detailsFieldKey]
  );

  return (
    <Stack>
      <FormControl
        error={!!(props.errorsObj && props.errorsObj[props.fieldKey])}
        id={props.fieldKey}
      >
        <Typography
          component="div"
          id={`${props.fieldKey}-radio-buttons-group`}
          sx={{
            color: hasError ? "error.main" : "inherit",
            whiteSpace: "pre-line",
            fontWeight: hasError ? "bold" : "400",
          }}
          dangerouslySetInnerHTML={{
            __html:
              props.allTitles &&
              props.allTitles[props.fieldKey].replace(/\n/g, "<br />"),
          }}
        />
        <RadioGroup
          sx={{ mt: "20px" }}
          aria-labelledby={`${props.fieldKey}-radio-buttons-group`}
          name={props.fieldKey}
          value={props.formObj[props.fieldKey as keyof typeof props.formObj]}
          onChange={props.handleChange}
        >
          <FormControlLabel value="כן" control={<Radio />} label="כן" />
          <FormControlLabel value="לא" control={<Radio />} label="לא" />
        </RadioGroup>
      </FormControl>
      {props.detailsFieldKey && (
        <Box sx={{ maxWidth: "600px" }}>
          <TextField
            sx={{
              my: "10px",
              ".MuiInputLabel-root": {
                color: hasError2 ? "error.main" : "inherit",
                whiteSpace: "pre-line",
                fontWeight: hasError2 ? "bold" : "400",
              },
            }}
            fullWidth
            size="small"
            variant="standard"
            label={props.allTitles && props.allTitles[props.detailsFieldKey]}
            name={props.detailsFieldKey}
            value={props.formObj[props.detailsFieldKey]}
            onChange={props.handleChange}
          />
        </Box>
      )}
    </Stack>
  );
};

const RankScale = (props: FieldProps) => {
  const hasError = !!(props.errorsObj && props.errorsObj[props.fieldKey]);
  const hasError2 = !!(
    props.errorsObj &&
    props.detailsFieldKey &&
    props.errorsObj[props.detailsFieldKey]
  );

  return (
    <Stack>
      <FormControl
        error={!!(props.errorsObj && props.errorsObj[props.fieldKey])}
        id={props.fieldKey}
      >
        <Typography
          component="div"
          id={`${props.fieldKey}-radio-buttons-group`}
          sx={{
            color: hasError ? "error.main" : "inherit",
            whiteSpace: "pre-line",
            fontWeight: hasError ? "bold" : "400",
          }}
          dangerouslySetInnerHTML={{
            __html:
              props.allTitles &&
              props.allTitles[props.fieldKey].replace(/\n/g, "<br />"),
          }}
        />
        {/* {props.fieldKeyTwo &&
				<FormLabel sx={{marginTop:'10px'}} id={`${props.fieldKeyTwo}-radio-buttons-group`}>{props.allTitles && props.allTitles[props?.fieldKeyTwo]}</FormLabel>

				}

{props.fieldKeyThree &&
				<FormLabel sx={{marginTop:'10px',maxWidth:"80%"}}  id={`${props.fieldKeyThree}-radio-buttons-group`}>{props.allTitles && props.allTitles[props?.fieldKeyThree]}</FormLabel>

				} */}

        <RadioGroup
          sx={{ mt: "20px", alignItems: "center" }}
          row
          aria-labelledby={`${props.fieldKey}-radio-buttons-group`}
          name={props.fieldKey}
          value={props.formObj[props.fieldKey as keyof typeof props.formObj]}
          onChange={props.handleChange}
        >
          <span style={{ marginLeft: "20px" }}>גבוה</span>
          {Array.from({ length: props.maxRank ?? 5 }, (_, i) => i + 1).map((rank) => (
            <FormControlLabel
              key={rank}
              value={rank}
              control={<Radio sx={{ marginLeft: "20px" }} />}
              label={rank}
            />
          ))}
          <span style={{ marginRight: "20px" }}>נמוך</span>
        </RadioGroup>
      </FormControl>
      {props.detailsFieldKey && (
        <Box sx={{ maxWidth: "600px" }}>
          <TextField
            sx={{
              my: "10px",
              ".MuiInputLabel-root": {
                color: hasError2 ? "error.main" : "inherit",
                whiteSpace: "pre-line",
                fontWeight: hasError2 ? "bold" : "400",
              },
            }}
            fullWidth
            size="small"
            variant="standard"
            label={props.allTitles && props.allTitles[props.detailsFieldKey]}
            name={props.detailsFieldKey}
            value={props.formObj[props.detailsFieldKey]}
            onChange={props.handleChange}
          />
        </Box>
      )}
    </Stack>
  );
};

const MultiSelect = (props: FieldProps) => {
  const hasError = !!(props.errorsObj && props.errorsObj[props.fieldKey]);
  // debugger;
  return (
    <FormControl
      component="fieldset"
      error={!!(props.errorsObj && props.errorsObj[props.fieldKey])}
    >
      <FormLabel
        sx={{
          color: hasError ? "#d32f2f" : "inherit", // Use theme error color or custom

          whiteSpace: "pre-line",
          fontWeight: hasError ? "bold" : "400",
        }}
        component="legend"
      >
        {props.allTitles && props.allTitles[props.fieldKey]}
      </FormLabel>
      <FormGroup>
        {props.options &&
          props.options.map((option: Option) => (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  checked={
                    !!(
                      props.formObj &&
                      props.formObj[props.fieldKey] &&
                      (props.formObj[props.fieldKey] as string[]).includes(
                        option.value
                      )
                    )
                  }
                  onChange={props.handleCheckboxChange}
                  name="recruiterRecommendation" // Ensure this matches the key used in the state update
                  value={option.value}
                />
              }
              label={option.label}
            />
          ))}
      </FormGroup>
    </FormControl>
  );
};
const RenderField = (props: FieldProps) => {
  let fieldContent;
  switch (props.fieldType) {
    case "yesNoRadio": {
      fieldContent = <YesNoRadio {...props} />;
      break;
    }

    case "rank": {
      fieldContent = <RankScale {...props} />;
      break;
    }
    case "text": {
      fieldContent = (
        <Box>
          <TextField
            error={!!(props.errorsObj && props.errorsObj[props.fieldKey])}
            label={props.allTitles && props.allTitles[props.fieldKey]}
            name={props.fieldKey}
            value={props.formObj && props.formObj[props.fieldKey]}
            onChange={props.handleChange}
            id={props.fieldKey}
          />
        </Box>
      );
      break;
    }
    case "multiline": {
      fieldContent = (
        <Stack>
          <Typography
            component="div"
            sx={{ 
              mb: "10px",
              color: !!(props.errorsObj && props.errorsObj[props.fieldKey]) ? "error.main" : "inherit",
              fontWeight: !!(props.errorsObj && props.errorsObj[props.fieldKey]) ? "bold" : "400"
            }}
            id={props.fieldKey}
            dangerouslySetInnerHTML={{
              __html:
                props.allTitles &&
                props.allTitles[props.fieldKey].replace(/\n/g, "<br />"),
            }}
          />
          <Box sx={{ maxWidth: "600px" }}>
            <TextField
              error={!!(props.errorsObj && props.errorsObj[props.fieldKey])}
              fullWidth
              multiline
              minRows={4}
              name={props.fieldKey}
              value={props.formObj && props.formObj[props.fieldKey]}
              onChange={props.handleChange}
            />
          </Box>
        </Stack>
      );
      break;
    }
    case "multiSelect": {
      fieldContent = <MultiSelect {...props} />;
      break;
    }
    default: {
      fieldContent = null;
    }
  }

  return fieldContent;
};

const clientCommands = axios.create({
  baseURL: "https://niloo-server.herokuapp.com",
 // baseURL: "https://niloo-server-staging-3c42ff48f81a.herokuapp.com",
 // baseURL: 'http://localhost:3030',
});

function App() {
  // const [isRtl, setIsRtl] = React.useState(true);
  const isRtl = true;

  const [isSent, setIsSent] = React.useState(false);

  const [submitInProgress, setSubmitInProgress] = React.useState(false);

  const [snackbarData, setSnackbarData] = React.useState<snackbarDataProps>({
    open: false,
    severity: "error",
    msg: "",
  });

  React.useLayoutEffect(() => {
    document.body.setAttribute("dir", isRtl ? "rtl" : "ltr");
  }, [isRtl]);

  const [formObj, setFormObj] = React.useState<IFormObj>({
    interviewType: "",
    interviewerName: "",
    applicantName: "",
    applicantNumber: "",

    leadership: "",
    leadershipDetails: "",
    recruiterRecommendation: [],
    businessOrientaion: "",
    businessOrientaionDetails: "",

    skills: "",
    skillsDetails: "",

    globalOrientaion: "",
    globalOrientaionDetails: "",

    relationships: "",
    relationshipsDetails: "",
    customerExp: "",
    customerExpDetails: "",
    relevantImpressions: "",
    evaluation: "",
    evaluationPros: "",
    evaluationCons: "",
    recommendation: "",
    relevantKnowledge: "",
    relevantKnowledgeB: "",

    // isRelated: '',
    isExcel: "",
    isXFactorTitle: "",
    isXFactor: "",

    englishVocabulary: "",
    englishGrammar: "",

    englishQuestion: "",
    impressionOfInterview: "",

    impressionRank: "",

    specialRequests: "",

    advisoryMatchB: "",
    advisoryMatchDetailsB: "",
    businessOrientaionB: "",
    businessOrientaionDetailsB: "",
    skillsB: "",
    skillsDetailsB: "",
    leadershipB: "",
    leadershipDetailsB: "",
    relationshipsB: "",
    relationshipsDetailsB: "",
    globalOrientaionB: "",
    globalOrientaionDetailsB: "",

    relevantImpressionsB: "",
    profileMatch: "",
    profileMatchDetails: "",

    // New fields for "ראיון מקצועי - מתמחים"
    leadershipInterns: "",
    leadershipInternsDetails: "",
    businessOrientaionInterns: "",
    businessOrientaionInternsDetails: "",
    skillsInterns: "",
    skillsInternsDetails: "",
    globalOrientaionInterns: "",
    globalOrientaionInternsDetails: "",
    relationshipsInterns: "",
    relationshipsInternsDetails: "",
    customerExpInterns: "",
    customerExpInternsDetails: "",
    personalResilience: "",
    personalResilienceDetails: "",
    exceptionalSkills: "",
    exceptionalSkillsHasSkills: "",
    exceptionalSkillsDetails: "",
    technologyAdoption: "",
    technologyAdoptionDetails: "",
  });

  const [errorsObj, setErrorsObj] = React.useState<Partial<IFormObj>>({});

  const isAdvisory =
    formObj?.interviewType === "מקצועי - advisory" ||
    formObj?.interviewType === 'מש"א - advisory';
  // Advisory forms use their own texts and a 1-3 scale; all other forms are unchanged.
  const activeTitles: IFormObj = isAdvisory
    ? { ...allTitles, ...advisoryTitles }
    : allTitles;
  const rankMax = isAdvisory ? 3 : 5;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = (event.target as HTMLInputElement).value;
    const fieldKey = (event.target as HTMLInputElement).name;

    const current = formObj;

    setFormObj({ ...current, [fieldKey]: val });
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target as HTMLInputElement;

    // Use the appropriate key for multi-select in your formObj
    const fieldKey: keyof IFormObj = "recruiterRecommendation"; // Make sure this is the correct key you want to update

    setFormObj((prevState) => {
      // Fetch the current array of selected values for the specific field
      const currentSelections = Array.isArray(prevState[fieldKey])
        ? (prevState[fieldKey] as string[])
        : [];

      // Update the array based on the checkbox state
      const updatedSelections = checked
        ? [...currentSelections, value] // Add the value if checked
        : currentSelections.filter(
            (selectedValue: string) => selectedValue !== value
          ); // Remove the value if unchecked

      // Return the new state with the updated selections for the field
      return { ...prevState, [fieldKey]: updatedSelections };
    });
  };
  const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = (event.target as HTMLInputElement).value;
    const fieldKey = (event.target as HTMLInputElement).name;

    const current = formObj;

    // to allow only digits
    const regexTerm = /^[0-9\b]+$/;
    if (val === "" || regexTerm.test(val)) {
      setFormObj({ ...current, [fieldKey]: val });
    }
  };

  const validateAllFields = React.useCallback(() => {
    let errors: any = {};
    let fields: string[] = [
      "interviewType",
      "interviewerName",
      "applicantName",
      "applicantNumber",

      // 'leadership',
      // // 'leadershipDetails',
      // 'businessOrientaion',
      // // 'businessOrientaionDetails',
      // 'skills',
      // // 'skillsDetails',
      // 'globalOrientaion',
      // // 'globalOrientaionDetails',
      // 'relationships',
      // // 'relationshipsDetails',

      // 'relevantImpressions',
    ];

    // if (formObj?.interviewType === 'מקצועי') {
    // 	fields.push('evaluationPros', 'evaluationCons', 'recommendation');
    // }
    // if (formObj?.interviewType === 'מש"א') {
    // 	fields.push('isRelated', 'englishVocabulary', 'englishGrammar', 'englishQuestion', 'impressionOfInterview', 'impressionRank', 'specialRequests');
    // }
    if (formObj?.interviewType === "מקצועי") {
      fields.push(


        "evaluationPros",
        "evaluationCons",
        "impressionRank",
    

        // New intern-specific fields
        "leadershipInterns",
        "businessOrientaionInterns",
        "skillsInterns",
        "globalOrientaionInterns",
        "relationshipsInterns",
        "customerExpInterns",
        "personalResilience",
        "exceptionalSkillsHasSkills",
        "technologyAdoption"
      );
    }
    if (formObj?.interviewType === 'מש"א') {
      fields.push(
        "leadershipInterns",
        "businessOrientaionInterns",
        "skillsInterns",
        "globalOrientaionInterns",
        "relationshipsInterns",
        "customerExpInterns",
        "personalResilience",
        "technologyAdoption",
        "isExcel",
   
        "recruiterRecommendation",
        //'englishQuestion',
        "impressionOfInterview",
        "impressionRank"

        //'specialRequests'
      );
    }

    if (formObj?.interviewType === "מקצועי-יחידני") {
      fields.push(
        "leadership",
        //'leadershipDetails',
        "businessOrientaion",
        //'businessOrientaionDetails',
        "skills",
        //'skillsDetails',
        "globalOrientaion",
        //'globalOrientaionDetails',
        "relationships",
        //'relationshipsDetails',
        "customerExp",
        //'customerExpDetails',
        "evaluationPros",
        "evaluationCons",
        "impressionRank",
        "relevantKnowledgeB",
        "isXFactor"
      );
    }

    if (formObj?.interviewType === 'מש"א-יחידני') {
      fields.push(
        "leadership",
        //'leadershipDetails',
        "businessOrientaion",
        //'businessOrientaionDetails',
        "skills",
        //'skillsDetails',
        "globalOrientaion",
        //'globalOrientaionDetails',
        "relationships",
        //'relationshipsDetails',
        "customerExp",
        //'customerExpDetails',
        "impressionRank",
        "relevantKnowledge",
        "impressionOfInterview"
      );
    }
    if (formObj?.interviewType === "מקצועי - advisory") {
      fields.push(
        "profileMatch",
        //'profileMatchDetails',
        "leadership",
        // 'leadershipDetails',
        // 'advisoryMatchDetailsB',
        "businessOrientaionB",
        //'businessOrientaionDetailsB',
        "skillsB",
        //'skillsDetailsB',
        "globalOrientaion",
        //	'globalOrientaionDetails',
        //'leadershipDetailsB',
        // 'leadershipDetailsB',
        "relationshipsB",
        // 'relationshipsDetailsB',
        "customerExp",
        //'customerExpDetails',
        //'globalOrientaionB',
        // 'globalOrientaionDetailsB',

        // "relevantImpressionsB",

        "evaluationPros",
        "evaluationCons",
        "impressionRank"
      );
    }
    if (formObj?.interviewType === 'מש"א - advisory') {
      fields.push(
        "profileMatch",
        "leadership",
        "businessOrientaionB",
        "skillsB",
        "globalOrientaion",
        "relationshipsB",
        "customerExp",
        "evaluationPros",
        "evaluationCons",
        "impressionRank"
      );
    }
    for (const field of fields) {
      const fieldValue = formObj[field as keyof typeof formObj];
      if (
        !fieldValue ||
        (Array.isArray(fieldValue) && fieldValue.length === 0)
      ) {
        errors[field] = "This field is required."; // Check if it's an array and if it's empty
      }
    }

    // Custom validation for exceptionalSkills - details field is required only if hasSkills is "כן" and interview type is "מקצועי"
    if (formObj?.interviewType === "מקצועי" && formObj.exceptionalSkillsHasSkills === "כן" && !formObj.exceptionalSkillsDetails) {
      errors.exceptionalSkillsDetails = "This field is required when exceptional skills are present.";
    }

    if (isSent) {
      setErrorsObj(errors);
    }

    return errors;
    // return Object.keys(errors).length;
  }, [formObj, isSent]);

  React.useEffect(() => {
    validateAllFields();
  }, [validateAllFields, formObj]);

  const handleSubmitCommands = async () => {
    console.log("handleSubmitCommands");

    setIsSent(true);
    // const errorsCount = validateAllFields();
    const errors = validateAllFields();
    const objKeys = Object.keys(errors);
    const errorsCount = objKeys.length;

    if (errorsCount > 0) {
      console.log("errorsCount", errorsCount, errors);
      const elem = document.querySelector(`#${objKeys[0]}`);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      setSubmitInProgress(true);
debugger;
      try {
        if (formObj?.applicantNumber) {
          const applicant = await sendCommand(
            "find-phone",
            formObj.applicantNumber
          );
          console.log(applicant);
          if (applicant?.CardId) {
            const activity = await sendCommand(
              "add-activity",
              "",
              applicant.CardId
            );
            console.log("activity", activity);

            const fileTextResponse = await sendCommand(
              "add-file",
              "",
              applicant.CardId
            );
            console.log("fileTextResponse", fileTextResponse);

            const updateCustom = await sendCommand(
              "update-custom-field",
              "",
              applicant.CardId
            );
            console.log("updateCustom", updateCustom);

            setSnackbarData({
              open: true,
              severity: "success",
              msg: "נשלח בהצלחה",
            });

            resetForm();
          } else {
            setSnackbarData({
              open: true,
              severity: "error",
              msg: "טלפון נייד של המועמד/ת לא נמצא במערכת",
            });
          }
        } else {
          console.log("no applicant number");
        }
      } catch (error) {
        console.log(error);
        setSnackbarData({ open: true, severity: "error", msg: "אירעה שגיאה" });
      }

      setSubmitInProgress(false);
    }
  };

  const resetForm = () => {
    setFormObj({
      interviewType: "",
      interviewerName: "",
      applicantName: "",
      applicantNumber: "",
      recruiterRecommendation: [],
      leadership: "",
      leadershipDetails: "",

      businessOrientaion: "",
      businessOrientaionDetails: "",

      skills: "",
      skillsDetails: "",

      globalOrientaion: "",
      globalOrientaionDetails: "",

      relationships: "",
      relationshipsDetails: "",
      customerExp: "",
      customerExpDetails: "",
      relevantImpressions: "",
      evaluation: "",
      evaluationPros: "",
      evaluationCons: "",
      recommendation: "",
      relevantKnowledge: "",
      relevantKnowledgeB: "",

      // isRelated: '',
      isExcel: "",
      isXFactorTitle: "",
      isXFactor: "",
      englishVocabulary: "",
      englishGrammar: "",

      englishQuestion: "",
      impressionOfInterview: "",

      impressionRank: "",

      specialRequests: "",

      advisoryMatchB: "",
      advisoryMatchDetailsB: "",
      businessOrientaionB: "",
      businessOrientaionDetailsB: "",
      skillsB: "",
      skillsDetailsB: "",
      leadershipB: "",
      leadershipDetailsB: "",
      relationshipsB: "",
      relationshipsDetailsB: "",
      globalOrientaionB: "",
      globalOrientaionDetailsB: "",

      relevantImpressionsB: "",
      profileMatch: "",
      profileMatchDetails: "",

      // New fields for "ראיון מקצועי - מתמחים"
      leadershipInterns: "",
      leadershipInternsDetails: "",
      businessOrientaionInterns: "",
      businessOrientaionInternsDetails: "",
      skillsInterns: "",
      skillsInternsDetails: "",
      globalOrientaionInterns: "",
      globalOrientaionInternsDetails: "",
      relationshipsInterns: "",
      relationshipsInternsDetails: "",
      customerExpInterns: "",
      customerExpInternsDetails: "",
      personalResilience: "",
      personalResilienceDetails: "",
      exceptionalSkills: "",
      exceptionalSkillsHasSkills: "",
      exceptionalSkillsDetails: "",
      technologyAdoption: "",
      technologyAdoptionDetails: "",
    });

    setIsSent(false);
  };

  const sendCommand = async (cmd: string, phone?: string, cardId?: string) => {
    let result;

    const commandData = {
      cmd,
      phone,
      formObj: JSON.stringify(formObj),
      cardId,
    };

    try {
      let response = await clientCommands.post("/actions", commandData);
      if (response.data) {
        result = response.data;
      } else {
        console.log("no response data");
      }
    } catch (error) {
      console.log(error);
    }

    return result;
  };

  const handleSnackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarData({ ...snackbarData, open: false });
  };

  return (
    <CacheProvider value={isRtl ? cacheRtl : cacheLtr}>
      <ThemeProvider theme={isRtl ? rtlTheme : ltrTheme}>
        <CssBaseline />
        <Container sx={{ py: "40px" }}>
          <Stack spacing="30px">
            <Box sx={{ textAlign: "center" }}>
              <img src={banner2} alt="banner2" style={{ width: "100%" }} />
              {/* <Typography variant="h3" gutterBottom component="div" style={{ padding: '20px' }}>
								<img src={logo} alt="Logo" style={{ marginLeft: 40 }} />
								טופס סיכום ראיון
							</Typography> */}
              {/* <img src={banner2} alt="banner2" style={{ width: '100%' }} /> */}
            </Box>

            <Box>
              <FormControl required error={!!errorsObj?.interviewType}>
                <FormLabel id="interview-type-radio-buttons-group">
                  {activeTitles?.interviewType}
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="interview-type-radio-buttons-group"
                  name="interviewType"
                  value={formObj?.interviewType}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="מקצועי"
                    control={<Radio />}
                    label="ראיון מקצועי - מתמחים"
                  />
                  <FormControlLabel
                    value='מש"א'
                    control={<Radio />}
                    label='ראיון מש"א - מתמחים'
                  />
                  <FormControlLabel
                    value="מקצועי-יחידני"
                    control={<Radio />}
                    label="ראיון מקצועי - יחידני"
                  />
                  <FormControlLabel
                    value='מש"א-יחידני'
                    control={<Radio />}
                    label='ראיון מש"א - יחידני'
                  />
                  <FormControlLabel
                    value="מקצועי - advisory"
                    control={<Radio />}
                    label="ראיון מקצועי - Advisory"
                  />
                  <FormControlLabel
                    value='מש"א - advisory'
                    control={<Radio />}
                    label='ראיון מש"א - Advisory'
                  />
                </RadioGroup>
              </FormControl>
            </Box>

            <RenderField
              fieldType="text"
              fieldKey="interviewerName"
              formObj={formObj}
              allTitles={activeTitles}
                  maxRank={rankMax}
              errorsObj={errorsObj}
              handleChange={handleChange}
            />

            <RenderField
              fieldType="text"
              fieldKey="applicantName"
              formObj={formObj}
              allTitles={activeTitles}
                  maxRank={rankMax}
              errorsObj={errorsObj}
              handleChange={handleChange}
            />

            <RenderField
              fieldType="text"
              fieldKey="applicantNumber"
              formObj={formObj}
              allTitles={activeTitles}
                  maxRank={rankMax}
              errorsObj={errorsObj}
              handleChange={handleNumberChange}
            />

            {/* For מש"א, מקצועי-יחידני, מש"א-יחידני - use original fields */}
            {(
              formObj?.interviewType === "מקצועי-יחידני" ||
              formObj?.interviewType === 'מש"א-יחידני') && (
              <>
                <RenderField
                  fieldType="rank"
                  fieldKey="leadership"
                  detailsFieldKey="leadershipDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="rank"
                  fieldKey="businessOrientaion"
                  detailsFieldKey="businessOrientaionDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                <RenderField
                  fieldType="rank"
                  fieldKey="skills"
                  detailsFieldKey="skillsDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                <RenderField
                  fieldType="rank"
                  fieldKey="globalOrientaion"
                  detailsFieldKey="globalOrientaionDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                <RenderField
                  fieldType="rank"
                  fieldKey="relationships"
                  detailsFieldKey="relationshipsDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="rank"
                  fieldKey="customerExp"
                  detailsFieldKey="customerExpDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                {/* <RenderField fieldType="multiline" fieldKey="relevantImpressions" formObj={formObj} allTitles={activeTitles}
                  maxRank={rankMax} errorsObj={errorsObj} handleChange={handleChange} /> */}
              </>
            )}

            {/* For מקצועי - use intern-specific fields */}
            {(formObj?.interviewType === "מקצועי" || formObj?.interviewType === 'מש"א') &&  (
              <>
                <RenderField
                  fieldType="rank"
                  fieldKey="leadershipInterns"
                  detailsFieldKey="leadershipInternsDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="rank"
                  fieldKey="businessOrientaionInterns"
                  detailsFieldKey="businessOrientaionInternsDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                <RenderField
                  fieldType="rank"
                  fieldKey="skillsInterns"
                  detailsFieldKey="skillsInternsDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                <RenderField
                  fieldType="rank"
                  fieldKey="globalOrientaionInterns"
                  detailsFieldKey="globalOrientaionInternsDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                <RenderField
                  fieldType="rank"
                  fieldKey="relationshipsInterns"
                  detailsFieldKey="relationshipsInternsDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />



                <RenderField
                  fieldType="rank"
                  fieldKey="customerExpInterns"
                  detailsFieldKey="customerExpInternsDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

<RenderField
                  fieldType="rank"
                  fieldKey="technologyAdoption"
                  detailsFieldKey="technologyAdoptionDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                <RenderField
                  fieldType="rank"
                  fieldKey="personalResilience"
                  detailsFieldKey="personalResilienceDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />


                <Typography variant="subtitle1" gutterBottom>
                    <Box dangerouslySetInnerHTML={{
              __html:
                allTitles &&
                allTitles["exceptionalSkills"].replace(/\n/g, "<br />"),
            }}></Box>
                  </Typography>
                  
            
                   <FormControl error={!!errorsObj?.exceptionalSkillsHasSkills}>
                    <FormLabel id="related-radio-buttons-group">
                      {activeTitles?.exceptionalSkillsHasSkills}
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="related-radio-buttons-group"
                      name="exceptionalSkillsHasSkills"
                      value={formObj?.exceptionalSkillsHasSkills}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="כן"
                        control={<Radio />}
                        label="כן"
                      />
                      <FormControlLabel
                        value="לא"
                        control={<Radio />}
                        label="לא"
                      />
                    </RadioGroup>
                  </FormControl>
                  
                  {formObj?.exceptionalSkillsHasSkills === "כן" && (
                    <Stack spacing="10px" sx={{ maxWidth: "600px" }}>
                      אם כן פרט:<br/>
                      איזו מיומנויות התבלטו במיוחד, מה הדוגמה וההתנהגות, למה זה מעיד על התאמה לתפקיד?
                      <TextField
                        multiline
                        minRows={4}
                        error={!!errorsObj?.exceptionalSkillsDetails}
                        label=""
                        fullWidth
                        name="exceptionalSkillsDetails"
                        value={formObj?.exceptionalSkillsDetails}
                        onChange={handleChange}
                      />
                    </Stack>
                  )}
        
                {/* <RenderField fieldType="multiline" fieldKey="relevantImpressions" formObj={formObj} allTitles={activeTitles}
                  maxRank={rankMax} errorsObj={errorsObj} handleChange={handleChange} /> */}
              </>
            )}

            {(formObj?.interviewType === "מקצועי - advisory" ||
              formObj?.interviewType === 'מש"א - advisory') && (
              <>
                <RenderField
                  fieldType="rank"
                  fieldKey="profileMatch"
                  detailsFieldKey="profileMatchDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                <RenderField
                  fieldType="rank"
                  fieldKey="leadership"
                  detailsFieldKey="leadershipDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="rank"
                  fieldKey="businessOrientaionB"
                  detailsFieldKey="businessOrientaionDetailsB"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="rank"
                  fieldKey="skillsB"
                  detailsFieldKey="skillsDetailsB"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="rank"
                  fieldKey="globalOrientaion"
                  detailsFieldKey="globalOrientaionDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="rank"
                  fieldKey="relationshipsB"
                  detailsFieldKey="relationshipsDetailsB"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="rank"
                  fieldKey="customerExp"
                  detailsFieldKey="customerExpDetails"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                {/* <RenderField fieldType="rank" fieldKey="globalOrientaionB" detailsFieldKey="globalOrientaionDetailsB" formObj={formObj} allTitles={activeTitles}
                  maxRank={rankMax} errorsObj={errorsObj} handleChange={handleChange} /> */}

                {/* <RenderField fieldType="multiline" fieldKey="relevantImpressionsB" formObj={formObj} allTitles={activeTitles}
                  maxRank={rankMax} errorsObj={errorsObj} handleChange={handleChange} /> */}
              </>
            )}

            {(formObj?.interviewType === "מקצועי" ||
              formObj?.interviewType === "מקצועי - advisory" ||
              formObj?.interviewType === 'מש"א - advisory' ||
              formObj?.interviewType === "מקצועי-יחידני") && (
              <>
                <Box>
                  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: "bold" }}>
                    <u>{activeTitles?.evaluation}</u>
                  </Typography>
                  <Stack spacing="10px" sx={{ maxWidth: "600px" }}>
                    <TextField
                      multiline
                      minRows={4}
                      error={!!errorsObj?.evaluationPros}
                      label={activeTitles?.evaluationPros}
                      fullWidth
                      name="evaluationPros"
                      value={formObj?.evaluationPros}
                      onChange={handleChange}
                    />
                    <TextField
                      multiline
                      minRows={4}
                      error={!!errorsObj?.evaluationCons}
                      label={activeTitles?.evaluationCons}
                      fullWidth
                      name="evaluationCons"
                      value={formObj?.evaluationCons}
                      onChange={handleChange}
                    />
                    {formObj?.interviewType === "מקצועי-יחידני" && (
                      <TextField
                        multiline
                        minRows={4}
                        error={!!errorsObj?.relevantKnowledgeB}
                        label={activeTitles?.relevantKnowledgeB}
                        fullWidth
                        name="relevantKnowledgeB"
                        value={formObj?.relevantKnowledgeB}
                        onChange={handleChange}
                      />
                    )}
                  </Stack>
                </Box>
                <Box></Box>
              </>
            )}

            {(
              formObj?.interviewType === "מקצועי-יחידני") && (
              <>
                <Box>
                  <Typography variant="subtitle1">
                    <u>{activeTitles?.isXFactorTitle}</u>
                  </Typography>
                  <RenderField
                    fieldType="yesNoRadio"
                    fieldKey="isXFactor"
                    formObj={formObj}
                    allTitles={activeTitles}
                  maxRank={rankMax}
                    errorsObj={errorsObj}
                    handleChange={handleChange}
                  />
                </Box>
              </>
            )}

            {(formObj?.interviewType === "מקצועי" ||
              formObj?.interviewType === "מקצועי - advisory" ||
              formObj?.interviewType === 'מש"א - advisory' ||
              formObj?.interviewType === "מקצועי-יחידני") && (
              <>
                <Box>
                  <RenderField
                    fieldType="rank"
                    fieldKey="impressionRank"
                    formObj={formObj}
                    allTitles={activeTitles}
                  maxRank={rankMax}
                    errorsObj={errorsObj}
                    handleChange={handleChange}
                  />
                </Box>
              </>
            )}

            {formObj?.interviewType === 'מש"א' && (
              <>
                {/* <Box>
									<FormControl error={!!errorsObj?.isRelated}>
										<FormLabel id="related-radio-buttons-group">{activeTitles?.isRelated}</FormLabel>
										<RadioGroup aria-labelledby="related-radio-buttons-group" name="isRelated" value={formObj?.isRelated} onChange={handleChange}>
											<FormControlLabel value="כן" control={<Radio />} label="כן" />
											<FormControlLabel value="לא" control={<Radio />} label="לא" />
										</RadioGroup>
									</FormControl>
								</Box> */}
                <Box>
                  <FormControl error={!!errorsObj?.isExcel}>
                    <FormLabel id="related-radio-buttons-group">
                      {activeTitles?.isExcel}
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="related-radio-buttons-group"
                      name="isExcel"
                      value={formObj?.isExcel}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="כן"
                        control={<Radio />}
                        label="כן"
                      />
                      <FormControlLabel
                        value="לא"
                        control={<Radio />}
                        label="לא"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>

                {/* <RenderField
                  fieldType="rank"
                  fieldKey="englishVocabulary"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                /> */}

                {/* <RenderField
                  fieldType="rank"
                  fieldKey="englishGrammar"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                /> */}
{/* 
                <RenderField
                  fieldType="multiline"
                  fieldKey="englishQuestion"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                /> */}
                <RenderField
                  fieldType="multiSelect"
                  fieldKey="recruiterRecommendation" // This should be the key where you want to store the selected values
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  options={options}
                  formObj={formObj}
                  handleCheckboxChange={handleCheckboxChange}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="multiline"
                  fieldKey="impressionOfInterview"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                <RenderField
                  fieldType="rank"
                  fieldKey="impressionRank"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />

                {/* <RenderField fieldType="multiline" fieldKey="specialRequests" formObj={formObj} allTitles={activeTitles}
                  maxRank={rankMax} errorsObj={errorsObj} handleChange={handleChange} /> */}
              </>
            )}

            {formObj?.interviewType === 'מש"א-יחידני' && (
              <>
                <RenderField
                  fieldType="multiline"
                  fieldKey="impressionOfInterview"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="multiline"
                  fieldKey="relevantKnowledge"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
                <RenderField
                  fieldType="rank"
                  fieldKey="impressionRank"
                  formObj={formObj}
                  allTitles={activeTitles}
                  maxRank={rankMax}
                  errorsObj={errorsObj}
                  handleChange={handleChange}
                />
              </>
            )}

            {/* משא - advisory: old English/Excel/summary fields removed per client spec; summary rank is rendered in the shared block above */}

            <Box sx={{ textAlign: "center" }}>
              <Button
                sx={{ maxWidth: "600px", my: "40px" }}
                fullWidth
                variant="contained"
                size="large"
                onClick={handleSubmitCommands}
                disabled={submitInProgress}
              >
                {submitInProgress ? <CircularProgress size="27px" /> : "שליחה"}
              </Button>
            </Box>
          </Stack>
        </Container>

        <Snackbar
          sx={{ minWidth: "350px" }}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={snackbarData.open}
          autoHideDuration={8000}
          onClose={handleSnackbarClose}
        >
          <Alert
            onClose={handleSnackbarClose}
            elevation={6}
            variant="filled"
            severity={snackbarData.severity}
            sx={{ width: "100%" }}
          >
            {snackbarData?.msg}
          </Alert>
        </Snackbar>
      </ThemeProvider>
    </CacheProvider>
  );
}

export default App;
